import React from 'react'
import styles from "../PopUp/PopUp.module.css"

const PopUp = ({ open, onClose, title, children }) => {
    if (!open) return null;
  return (
  <div className={styles.overlay}>
      <div className={styles.popup}>
        {/* Header */}
        <div className={styles.header}>
          <h2 className={styles.KnowledgeTitle}>{title}</h2>
          <button className={styles.closeBtn} onClick={onClose}>✖</button>
        </div>

        {/* Body */}
        <div className={styles.body}>
          {children}
        </div>

      
      </div>
    </div>
  )
}

export default PopUp
